/* eslint-disable jsx-a11y/anchor-is-valid */
import {useCallback} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useKeycloak} from '@react-keycloak/web'

export function Login() {
  const {keycloak, initialized} = useKeycloak()

  const loginKeycloak = useCallback(() => {
    keycloak.login()
  }, [keycloak])

  if (!initialized) {
    return <h4> Carregando ... </h4>
  }

  return (
    <div className='w-100'>
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Entrar</h1>
        <div className='text-gray-500 fw-semibold fs-6'>
          Sistema de Gestão Mediúnica — Vale do Amanhecer
        </div>
      </div>
      {/* end::Heading */}

      {/* begin::Login options */}
      <div className='d-grid mb-9'>
        <button
          type='button'
          className='btn btn-primary btn-flex flex-center text-nowrap w-100 py-4'
          onClick={loginKeycloak}
        >
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/osoec-logo-rounded.png')}
            className='h-25px me-3 rounded-circle'
          />
          <span className='fw-bolder fs-5'>Entrar com conta OSOEC</span>
        </button>
      </div>
      {/* end::Login options */}

      <div className='text-gray-500 text-center fw-semibold fs-7'>
        Problemas com acesso?{' '}
        <a href='https://wa.me/5561996350435' className='link-primary'>
          Fale com o suporte
        </a>
      </div>
    </div>
  )
}
